import backendHttpClient, { administrationHttpClient } from '../../../http/axios/axios-http-client';
import { RecommendedHealers } from './dto/recommended-healers';

const PUBLIC_HEALER_SELECTION_ENDPOINT = '/public/healers-recommendation';
const ADMINISTRATION_HEALER_SELECTION_ENDPOINT = '/public/healer-recommendations';

export interface HealerSelectionGateway {
  getRecommendedHealersForClient(clientUserProfileId?: string): Promise<RecommendedHealers>;
  previewHealerProfileInHealerSelection(recommendationId: string): Promise<RecommendedHealers>;
  markRecommendationAsOpened(recommendationId: string): Promise<void>;
  markRecommendationAsBookHealerButtonClicked(recommendationId: string): Promise<void>;
}

export class HealerSelectionGateway implements HealerSelectionGateway {
  async getRecommendedHealersForClient(clientUserProfileId?: string): Promise<RecommendedHealers> {
    const endpoint = `${PUBLIC_HEALER_SELECTION_ENDPOINT}/${clientUserProfileId}`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }

  async previewHealerProfileInHealerSelection(healerUserProfileId: string): Promise<RecommendedHealers> {
    const endpoint = `${PUBLIC_HEALER_SELECTION_ENDPOINT}/${healerUserProfileId}/preview`;
    const response = await backendHttpClient.request({
      url: endpoint,
      method: 'GET',
    });
    return response.data;
  }

  async markRecommendationAsOpened(recommendationId: string): Promise<void> {
    const endpoint = `${ADMINISTRATION_HEALER_SELECTION_ENDPOINT}/${recommendationId}/mark-as-opened`;
    await administrationHttpClient.request({
      url: endpoint,
      method: 'PUT',
    });
  }

  async markRecommendationAsBookHealerButtonClicked(recommendationId: string): Promise<void> {
    const endpoint = `${ADMINISTRATION_HEALER_SELECTION_ENDPOINT}/${recommendationId}/book-healer-clicked`;
    await administrationHttpClient.request({
      url: endpoint,
      method: 'PUT',
    });
  }

  async markHealerPageAsOpened(recommendationId: string, healerId: string): Promise<void> {
    const endpoint = `${ADMINISTRATION_HEALER_SELECTION_ENDPOINT}/${recommendationId}/event`;
    await administrationHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: {
        event: 'EVENT_OPEN_HEALER_PAGE',
        payload: {
          healerId: healerId,
        },
      },
    });
  }
}
